import React from 'react';
import { createBrowserHistory } from 'history';
import { SWRConfig } from 'swr';
import { ConnectedRouter } from 'connected-react-router';
import { render, unmountComponentAtNode } from 'react-dom';
import Loadable from 'react-loadable';
import { hot } from 'react-hot-loader';
import { Provider } from 'react-redux';
import { setupFeatureFramework, identitySelector } from '@surfline/web-common';

import { CookiesProvider } from 'react-cookie';

import configureStore from '../stores';
import rootReducer from '../reducers';
import config from '../config';

import '../styles/base.scss';

const TWENTY_MIN_DEDUPE_INTERVAL = 1200000;
const root = document.querySelector('#root');
const preloadedState = window.__DATA__; // eslint-disable-line no-underscore-dangle

// Create a history of your choosing (we're using a browser history in this case)
const history = createBrowserHistory();

const store = configureStore(preloadedState, history);

const mount = () => {
  // eslint-disable-next-line global-require,import/newline-after-import
  const Routes = hot(module)(require('../components/Routes').default);

  Loadable.preloadReady().then(() => {
    render(
      <CookiesProvider>
        <Provider store={store}>
          <ConnectedRouter history={history}>
            <SWRConfig
              value={{
                shouldRetryOnError: false,
                revalidateOnFocus: false,
                dedupingInterval: TWENTY_MIN_DEDUPE_INTERVAL,
              }}
            >
              <React.StrictMode>
                <Routes />
              </React.StrictMode>
            </SWRConfig>
          </ConnectedRouter>
        </Provider>
      </CookiesProvider>,
      root
    );
  });
};

setupFeatureFramework(config.appKeys.splitio, identitySelector(store.getState()))
  .then(mount)
  .catch(mount);

if (module.hot) {
  module.hot.accept('../components/Routes', () => {
    unmountComponentAtNode(root);
    mount();
  });
  module.hot.accept('../reducers', () => {
    store.replaceReducer(rootReducer(history));
  });
}
